import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BSButton from 'react-bootstrap/Button';

import FileSize from '../component/FileSize'

const DownloadButton = (props) => {

  let {
    size,
    block,
    onClick = () => {}
  } = props;

  const { t } = useTranslation();

  return (
    <BSButton variant="download" size="xl" block={block} onClick={() => onClick()}>
      <i className="fa fa-download fa-fw"></i><span className="ml-2">{t('download')}</span><small className="ml-2">(<FileSize documentSizeBytes={size}/>)</small>
    </BSButton>
  )

};

DownloadButton.propTypes = {
  size: PropTypes.string,
};

export default DownloadButton;
